import React, { Component } from 'react';
import Select from 'react-select';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TimePicker from 'material-ui/TimePicker';
import TextField from 'material-ui/TextField';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorage from '../../services/LocalStorageService'; var ls = LocalStorage;

const actionOptions = [
  { label: 'ON', value: 'ON', answer: 1 },
  { label: 'OFF', value: 'OFF', answer: 0 }
];

const daysOptions = [
  { label: 'Sunday', value: 'Sunday' , day: 0 },
  { label: 'Monday', value: 'Monday' , day: 1 },
  { label: 'Tuesday', value: 'Tuesday', day: 2 },
  { label: 'Wednesday', value: 'Wednesday' , day: 3 },
  { label: 'Thrusday', value: 'Thrusday' , day: 4 },
  { label: 'Friday', value: 'Friday' , day: 5 },
  { label: 'Saturday', value: 'Saturday' , day: 6 },
];

export default class NewSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allRooms: [],
      allSwitches: this.props.details && this.props.details.allSwitches ? this.props.details.allSwitches : [],

      scheduleTime: this.props.details && this.props.details.timeObject ? new Date(this.props.details.timeObject) : new Date(),
      scheduleHours: this.props.details && this.props.details.hour ? this.props.details.hour : new Date().getHours(),
      scheduleMins: this.props.details && this.props.details.mins ? this.props.details.mins : new Date().getMinutes(),

      scheduleName: this.props.details && this.props.details.scheduleName ? this.props.details.scheduleName : '',
      scheduleDays: this.props.details && this.props.details.days ? this.getDaysInFormat(this.props.details.days) : '',

      scheduleDetails: this.props.details && this.props.details.scheduleDetails ? this.props.details.scheduleDetails :[{
        hotel_room_id: '',
        switch: {
          value: '',
          details: ''
        },
        roomSwitches: [],
        action: ''
      }],

      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        all_services: [],
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getAllRooms();
    this.gettHotelDevices();
  }

  getDaysInFormat(daysPresent) {
    let recievedDays = [];
    daysPresent.forEach((day) => {
      if (day == 0) {
        recievedDays.push({ label: 'Sunday', value: 'Sunday' , day: 0 });

      } else if (day == 1) {
        recievedDays.push({ label: 'Monday', value: 'Monday' , day: 1 });

      } else if (day == 2) {
        recievedDays.push({ label: 'Tuesday', value: 'Tuesday', day: 2 });

      } else if (day == 3) {
        recievedDays.push({ label: 'Wednesday', value: 'Wednesday' , day: 3 });

      } else if (day == 4) {
        recievedDays.push({ label: 'Thrusday', value: 'Thrusday' , day: 4 });

      } else if (day == 5) {
        recievedDays.push({ label: 'Friday', value: 'Friday' , day: 5 });

      } else if (day == 6) {
        recievedDays.push({ label: 'Saturday', value: 'Saturday' , day: 6 });
      }
    });
    return recievedDays;
  }

  getAllRooms() {
    ds.getSomeRooms(ls.getUserDetails().hotel_id, 0, 0,
      data => {
        let rooms = [];
        if (data && data.length) {
          data.forEach((roomPresent) => {
            const obj = {
              label: roomPresent.hotel_room_id ? roomPresent.hotel_room_id.name : 'NA',
              value: roomPresent.hotel_room_id ? roomPresent.hotel_room_id._id : 'NA',
            }
            rooms.push(obj);
          });
        }
        this.setState({
          allRooms: rooms,
        });
      }, err => {}
    );
  }

  gettHotelDevices() {
    ds.getAllPresentDevices(
      data => {
        this.setState({
          allSwitches: data.switchAppliances,
        });
      }, 
      err => {}
    )
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

  handleScheduleChanges(index, field, e){ // recieves the arguments in reverse order
    if (field == 'hotel_room_id') {
      let switches = [];
      if (this.state.allSwitches && this.state.allSwitches.length) {
        this.state.allSwitches.forEach((switchPresent) => {
          if (e.value.toString() == (switchPresent.hotel_room_id && switchPresent.hotel_room_id.toString())) {
            const obj = {
              label: switchPresent.name,
              value: switchPresent.name,
              details: {
                UDid: switchPresent.UDid,
                deviceId: switchPresent.device_id,
                actionType: "switchAction",
                switch_no: parseInt(switchPresent.switch_no),
                switch_appliance_id: switchPresent._id,
                hotel_room_id: e.value
              }
            };
            switches.push(obj);
          }
        });
      }

      if (this.props.details && this.props.details._id) { // for updating the room options 
        this.props.details.scheduleDetails[index].roomSwitches = switches;

      } else {
        this.state.scheduleDetails[index].roomSwitches = switches;
      }
    }

    let {scheduleDetails} = this.state;
    
    if (field == 'switch') {

      scheduleDetails[index][field].value = e.value;
      scheduleDetails[index][field].details = e.details;

    } else {
      scheduleDetails[index][field] = e.value;
    }

		this.setState({
			scheduleDetails
    });

	}

  createSchedule(e) {
    e.preventDefault();

    let actionArray = [];

    if (this.state.scheduleDetails && this.state.scheduleDetails.length) {
      this.state.scheduleDetails.forEach((schedulePresent) => {

        if (schedulePresent.switch.details) {

          if (this.props.details && this.props.details._id) {
            const id = 
              schedulePresent.switch.details.switch_appliance_id._id ? 
                schedulePresent.switch.details.switch_appliance_id._id 
              : 
              schedulePresent.switch.details.switch_appliance_id;
            
            const uId = 
              schedulePresent.switch.details.UDid._id ? 
                schedulePresent.switch.details.UDid._id 
              : 
              schedulePresent.switch.details.UDid;

            schedulePresent.switch.details.switch_appliance_id = id;
            schedulePresent.switch.details.UDid = uId;

          }

          if (schedulePresent.action == 'ON') {
            schedulePresent.switch.details.switch_state = 1;

          } else {
            schedulePresent.switch.details.switch_state = 0;
          }

          actionArray.push(schedulePresent.switch.details);
        }
      });
    }

    if (actionArray && actionArray == 0) {
      let dialog;
      dialog = {
        open: true,
        head: 'Actions Required',
        body: 'Please Select Atleast One Action',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      };

      this.setState({
        dialog: dialog
      });
      return;
    }

    if (!this.state.scheduleName) {
      let dialog;
      dialog = {
        open: true,
        head: 'Name Required',
        body: 'Please Provide A Name to Schedule',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      };
      this.setState({
        dialog: dialog
      });
      return;
    }

    let daysArray = [];
    this.state.scheduleDays.forEach((daysPresent) => {
      daysArray.push(daysPresent.day);
    });

    const payload = {
      scheduleName: this.state.scheduleName,
      hour: this.state.scheduleHours,
      mins: this.state.scheduleMins,
      isRepeat: true,
      days: daysArray,
      isActive: true,
      actions: actionArray
    };

    if (this.props.details && this.props.details._id) {
      payload.id = this.props.details._id;

      ds.postEditSchedule(payload,
        data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Schedule Edited Successfully!",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }

          let evt = new CustomEvent('updateScheduleTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            dialog: dialog
          });

        },
        err => {}
      );

    } else {
      ds.postCreateSchedule(payload,
        data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Schedule Created Successfully!",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }

          let evt = new CustomEvent('updateScheduleTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            scheduleName: '',
            scheduleDays: '',
            scheduleDetails: [{
              hotel_room_id: '',
              switch: {
                value: '',
                details: ''
              },
              action: ''
            }],
            scheduleTime: new Date(),
            scheduleHours: new Date().getHours(),
            scheduleMins: new Date().getMinutes(),
            dialog: dialog
          });

        },
        err => {}
      );
    }
  }

  addScheduleDetail(){
    let {scheduleDetails} = this.state;
    let length = 0;

    if (scheduleDetails && scheduleDetails.length) {
      length = scheduleDetails.length - 1;

      scheduleDetails.push({
        hotel_room_id: this.props.details && this.props.details._id ? '' : scheduleDetails[length].hotel_room_id ? scheduleDetails[length].hotel_room_id: '',
        switch: {
          value: '',
          details: ''
        },
        action: ''
      });
    }

		this.setState({
      scheduleDetails
      
    }, () => {
      if (
        this.state.scheduleDetails[length].hotel_room_id && 
        this.state.scheduleDetails[length].hotel_room_id != ''
      ) {
        const index = length + 1;
        const e = {
          value: this.state.scheduleDetails[length].hotel_room_id
        };
        this.handleScheduleChanges(index, 'hotel_room_id', e)
      }
    });
	}

  deleteSchedule(index) {
    if(this.state.scheduleDetails && this.state.scheduleDetails.length>1){
			let {scheduleDetails} = this.state;
			scheduleDetails.splice(index,1);
			this.setState({
				scheduleDetails
			});
		}
  }

  render() {
    return (
      <Box header={this.props.details ? 'Edit Schedule' : 'New Schedule'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12 zeroPadding">
          <form onSubmit={this.createSchedule.bind(this)}>
            <fieldset>
              <section className="col-sm-4">
                <div className="false-placeholder">
                  Schedule Time
                </div>

                <TimePicker
                  format="ampm"
                  autoOk
                  hintText="Select Time"
                  className="w-100"
                  value={this.state.scheduleTime}
                  onChange={(e, value) => {
                    const hours = new Date(value).getHours();
                    const mins = new Date(value).getMinutes();
                    this.setState({
                      scheduleTime: value,
                      scheduleHours: hours,
                      scheduleMins: mins
                    });
                  }}
                />
              </section>

              <section className="col-sm-4">
                <div className="false-placeholder">
                  Schedule Name
                </div>

                <TextField
                  name="scheduleName"
                  className="w-100"
                  value={this.state.scheduleName}
                  onChange={(e, value) => {
                    this.setState({
                      scheduleName: value
                    });
                  }}
                />

              </section>

              <section className="col-sm-4">
                <div className="false-placeholder">
                  Schedule Days
                </div>

                <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={daysOptions}
                  searchable={true}
                  placeholder="Select Schedule Days"
                  multi={true}
                  value={this.state.scheduleDays}
                  onChange={(newValue) => {
                    this.setState({
                      scheduleDays: newValue,
                    });
                  }}
                />

              </section>

              <section className="col-sm-12 mt-1vw zeroPadding">
                <section className="col-sm-6">
                  <div className="false-placeholder">Select Rooms and Devices For Schedule</div>
                </section>

                <section className="col-sm-6 zeroPadding">
                  <i className="material-icons primary pull-right"
                    style={{
                      cursor:'pointer',
                    }}
                    onClick={this.addScheduleDetail.bind(this)}
                  >
                    add_circle
                  </i>
                </section>
              </section>

              <section className="col-sm-12 zeroPadding">
                {
  								this.state.scheduleDetails.map((schedule, index)=>{
  									return <div key = {index} className="mt-1vw col-sm-12">
                      <section className="col-sm-4 zeroPadding">
                        <label className="false-placeholder">Room</label>
                        <Select options={ this.state.allRooms } value = {schedule.hotel_room_id}
                          onChange={this.handleScheduleChanges.bind(this, index, "hotel_room_id")}
                        />
                      </section>

                      {
                        <section className="col-sm-4">
                          <label className="false-placeholder">Switch</label>
                          <Select options={ schedule.roomSwitches } 
                            value = {schedule.switch.value}
                            onChange={this.handleScheduleChanges.bind(this, index, "switch")}
                            disabled={!schedule.hotel_room_id}
                          />
                        </section>
                      }

                      {
                        <section className="col-sm-3">
                          <label className="false-placeholder">Action</label>
                          <Select options={ actionOptions } value = {schedule.action}
                            onChange={this.handleScheduleChanges.bind(this, index, "action")}
                            disabled={!schedule.switch.value}
                          />
                        </section>
                      }

  										<section  className="col-sm-1">
                        {
                          this.state.scheduleDetails.length > 1 ?
                            <i className="material-icons warn-fg pull-right mt-30px"
                              style={{cursor:'pointer'}}
                              onClick={this.deleteSchedule.bind(this, index)}
                            >
                              delete
                            </i>
                          : null
                        }
  										</section>

  									</div>
  								})
                }
              </section>

            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label={this.props.details && this.props.details._id ? 'Save' : 'Create'}
                primary
                onClick={this.createSchedule.bind(this)}
              />
              <span className="space"></span>
              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>

        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/schedule/NewSchedule.js